
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_10sst_9",
  "input": "awsui_input_2rhyz_10sst_13",
  "input-readonly": "awsui_input-readonly_2rhyz_10sst_62",
  "input-invalid": "awsui_input-invalid_2rhyz_10sst_106",
  "input-warning": "awsui_input-warning_2rhyz_10sst_109",
  "input-type-search": "awsui_input-type-search_2rhyz_10sst_112",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_10sst_122",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_10sst_125",
  "input-container": "awsui_input-container_2rhyz_10sst_129",
  "input-field": "awsui_input-field_2rhyz_10sst_134",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_10sst_158",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_10sst_173",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_10sst_181",
  "input-field-warning": "awsui_input-field-warning_2rhyz_10sst_195",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_10sst_209",
  "input-field-no-border": "awsui_input-field-no-border_2rhyz_10sst_209",
  "grouped": "awsui_grouped_2rhyz_10sst_224",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_10sst_231",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_10sst_235",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_10sst_241",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_10sst_245",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_10sst_249",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_10sst_255",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_10sst_259",
  "grouped-with-error": "awsui_grouped-with-error_2rhyz_10sst_263",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_10sst_291",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_10sst_291",
  "grouped-with-warning": "awsui_grouped-with-warning_2rhyz_10sst_297",
  "grouped-row-first": "awsui_grouped-row-first_2rhyz_10sst_331",
  "input-prefix": "awsui_input-prefix_2rhyz_10sst_358",
  "input-suffix": "awsui_input-suffix_2rhyz_10sst_359",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_10sst_373",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_10sst_382",
  "input-icon-start": "awsui_input-icon-start_2rhyz_10sst_408",
  "input-icon-end": "awsui_input-icon-end_2rhyz_10sst_415",
  "input-button-right": "awsui_input-button-right_2rhyz_10sst_421",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_10sst_425",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_10sst_428",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_10sst_432",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_10sst_435",
  "inline-label": "awsui_inline-label_2rhyz_10sst_425",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_10sst_460"
};
  